<template>
  <div class="login-container">
    <div class="container">
      <div class="text-center mb-4">
        <div class="blinki-logo-container">
          <div class="blinki-logo"></div>
        </div>
      </div>
      <div class="dflex justify-content-center">
        <p class="text-center text-white">Veuillez utiliser les navigateurs recommandés ci-dessous.</p>
      </div>
      <div class="d-flex justify-content-center">
        <a href="https://www.google.com/intl/fr/chrome/" class="browser" data-toggle="tooltip" data-placement="top" title="Téléchargez Google Chrome">
          <img src="@/assets/images/chrome.png" width="60" alt="Google Chrome">
        </a>
        <a href="https://www.mozilla.org/fr/exp/firefox/new/" class="browser" data-toggle="tooltip" data-placement="top" title="Téléchargez Mozilla Firefox">
          <img src="@/assets/images/firefox.png" width="65" alt="Mozilla Firefox">
        </a>
        <a href="https://www.microsoft.com/en-us/edge" class="browser" data-toggle="tooltip" data-placement="top" title="Téléchargez Microsoft Edge">
          <img src="@/assets/images/edge.png" width="60" alt="Microsoft Edge">
        </a>
        <a href="https://www.opera.com/fr" class="browser" data-toggle="tooltip" data-placement="top" title="Téléchargez Opera">
          <img src="@/assets/images/opera.png" width="60" alt="Opera">
        </a>
      </div>
    </div>
      <div class="footer">
        <div class="flex f-center f-j-center">
          <small class="mt-2 mb-3 text-center color-white">Blinki © {{year}}</small>
        </div>
      </div>
  </div>
</template>

<script>
  export default {
    data() {
      document.addEventListener('contextmenu', event => event.preventDefault());
      const date = new Date();
      return {
        year: date.getFullYear()
      };
    },
  }
</script>

<style lang="scss" scoped>
  .browser {
    padding: 0 15px;
    filter: brightness(0.6);
    transition: transform 0.8s, filter 0.5s;
  }
  .browser:hover {
    filter: brightness(1);
    transform: rotate(360deg);
  }
  .footer {
    position: fixed;
    bottom: 40px;
  }
</style>
